package com.eladfinish.bible.contest.screens.pyramidCrossword.model

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.intOrNull
import kotlinx.serialization.json.jsonPrimitive

/**
 * Accepts both JSON numbers (1) and JSON strings ("1") and converts to Int.
 */
object IntOrStringSerializer : KSerializer<Int> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("IntOrString", PrimitiveKind.INT)

    override fun serialize(encoder: Encoder, value: Int) {
        encoder.encodeInt(value)
    }

    override fun deserialize(decoder: Decoder): Int {
        // Works only for JSON decoding
        val jsonDecoder = decoder as? JsonDecoder ?: return decoder.decodeInt()
        val primitive: JsonPrimitive = jsonDecoder.decodeJsonElement().jsonPrimitive

        return primitive.intOrNull
            ?: primitive.content.trim().toIntOrNull()
            ?: 0
    }
}
